// extracted by mini-css-extract-plugin
export default {"title":"RenderTitles_title__n+iT3","subTitle":"RenderTitles_subTitle__dCJt4"};